/* eslint-disable no-return-assign,react/no-unused-state,no-nested-ternary */
import React from 'react';
import { computed } from 'mobx';
import { List, InputItem, Checkbox, Button, Flex, Modal, Icon, Toast } from 'antd-mobile';
import jsBridge from '@/common/plugins/cmiotHelper/js-bridge';
import Header from '../common/header';

import './input_wifi.less';

class InputWifi extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputHiddenWifi: false,
      showPw: true,
      modal2: false,
      noPassword: false,
      c71ConfigType: '',
    };
    this.wifiType = [
      {
        label: '无',
        value: '无',
      },
      {
        label: 'WPA',
        value: 'WPA',
      },
      {
        label: 'WPA2',
        value: 'WPA2',
      },
      {
        label: 'WEP',
        value: 'WEP',
      },
    ];
  }

  componentWillMount() {
    const { bindCameraStore: { getDeviceTypeName, setTitle } } = this.props;
    setTitle(`${getDeviceTypeName()}连接Wi-Fi`);
  }

  componentDidMount() {
    const { bindCameraStore: { setWifiInfo } } = this.props;
    // 监听 用户退出app切换wifi后返回界面接收新的wifi
    jsBridge.on('ADD_CAMERA_SEND_CONNECT_WIFI_NAME', (d) => {
      if (d.data.wifiName) {
        setWifiInfo('wifiName', d.data.wifiName);
        setWifiInfo('wifiPassword', '');
      }
    });
    this.getConnectInitInfo();
    // 清空wifi密码
    setWifiInfo('wifiPassword', '');
  }

  componentWillUnmount() {
    // 移除监听
    jsBridge.off('ADD_CAMERA_SEND_CONNECT_WIFI_NAME', (d) => { });
  }

  onClose = key => () => {
    this.setState({
      [key]: false,
    });
  };

  onChangeVal = key => (val) => {
    const { bindCameraStore: { setWifiInfo } } = this.props;
    setWifiInfo(key, val);
  };

  getConnectInitInfo = () => {
    const { bindCameraStore: { setWifiInfo } } = this.props;

    // 主动向app发请求获取初始化信息
    jsBridge.send({
      f: 'FLAG_ADD_CAMERA',
      tk: 'ADD_CAMERA_GET_CONNECT_WIFI_NAME',
      p: {
        cb: true,
      },
    }).then((d) => {
      if (d && d.data) {
        setWifiInfo('wifiName', d.data.wifiName);
      }
    });
  };

  @computed get wifiInfo() {
    return this.props.bindCameraStore.wifiInfo;
  }

  @computed get nextWayState() {
    const { wifiInfo } = this.props.bindCameraStore;
    return wifiInfo.wifiName;
  }

  @computed get qrCodeFiled() {
    return this.props.bindCameraStore.qrCodeFiled;
  }

  // 切换显示或者隐藏密码
  togglePw = () => {
    this.setState(prevState => ({
      showPw: !prevState.showPw,
    }));
  };

  // 切换显示或隐藏 wifi
  toggleWifiType = () => {
    const { bindCameraStore: { setWifiInfo } } = this.props;

    setWifiInfo('wifiName', '');
    setWifiInfo('wifiPassword', '');

    this.setState(prevState => ({
      inputHiddenWifi: !prevState.inputHiddenWifi,
    }));
  };

  chooseWifiType = (wifiType) => {
    const { bindCameraStore: { setWifiInfo } } = this.props;

    setWifiInfo('wifiType', wifiType);

    this.setState({
      modal2: false,
    });
  };

  showModal = key => (e) => {
    e.preventDefault(); // 修复 Android 上点击穿透
    this.setState({
      [key]: true,
    });
  };

  switchWifi = () => {
    const { userAgent } = window.navigator;
    const { bindCameraStore: { setWifiInfo } } = this.props;

    if (/android/i.test(userAgent)) {
      jsBridge.send({
        f: 'FLAG_ADD_CAMERA',
        tk: 'ADD_CAMERA_SHOW_WIFI_LIST',
        p: {
          cb: true,
        },
      }).then((d) => {
        if (d && d.data && d.data.wifiName) {
          setWifiInfo('wifiName', d.data.wifiName);
        }
      });
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      // @TODO 是否需要回调
      jsBridge.send({
        f: 'FLAG_NEW_PAGE_LOCAL',
        tk: 'WINDOW_SYSTEM_SETTING',
      });
    }
  };

  goNext = (key) => {
    const { bindCameraStore, history } = this.props;
    const { specialDevice, deviceName } = bindCameraStore;

    switch (deviceName) {
      // 声波绑定
      case 'd1':
        history.push('/send_sound');
        break;
      default:
        if (specialDevice[0] === deviceName && key === 'btn') {
          // c71特有步骤 先跳连接界面
          bindCameraStore.setSmartConfig(true);
          history.push('/connecting');
        } else {
          bindCameraStore.setSmartConfig(false);
          history.push('/qrcode_wifi');
        }
        break;
    }
  };

  closePasswordTips = () => {
    this.setState({ noPassword: false });
    this.goNext(this.state.c71ConfigType);
  };

  handleSubmit = key => () => {
    const { wifiName, wifiPassword } = this.wifiInfo;
    const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
    if (!wifiName) {
      Toast.info('你还未输入内容', 1);
      return;
    }
    this.setState({
      c71ConfigType: key,
    });
    if (!wifiPassword) {
      this.setState({
        noPassword: true,
      });
      return;
    }
    if (wifiPassword && reg.test(wifiPassword)) {
      Toast.info('密码不能输入中文', 1);
      return;
    }
    if (!this.nextWayState) return;
    this.goNext(key);
  };

  closeFiled = () => {
    this.props.bindCameraStore.setQrCodeFiled(false);
  };

  imgLoaded = () => {
    const minHeight = this.dimg.parentElement.clientHeight;
    const designImgHeight = this.dimg.clientHeight;
    this.dimg.parentElement.style.height = `${minHeight}px`;
    this.dimg.style.marginTop = `${(minHeight - designImgHeight) / 2}px`;
    this.dimg.style.opacity = '1';
  };

  inputWifiMp3Src = () => {
    const { deviceName } = this.props.bindCameraStore;

    const prefix = '/app_h5/public/common/audio';

    switch (deviceName) {
      case 'c52':
        return `${prefix}/setup_hemu_input_ssid_${deviceName}.mp3`;
      case 'hdc-51':
        return `${prefix}/setup_hemu_input_ssid_hdc-51.mp3`;
      case 'hdc-55':
        return `${prefix}/setup_hemu_input_ssid_hdc-51.mp3`;
      default:
        return `${prefix}/setup_hemu_input_ssid.mp3`;
    }
  };

  render() {
    const { CheckboxItem } = Checkbox;
    const { inputHiddenWifi, showPw, noPassword } = this.state;
    const { deviceName, specialDevice, getDeviceTypeName } = this.props.bindCameraStore;

    return (
      <Flex direction="column" className="input-wifi vh-100">
        <Header fromH5={1} />
        <div className={`wifi-form ${deviceName === 'c71' ? 'smart-config' : ''}`}>
          <List>
            <InputItem
              type="text"
              placeholder="Wi-Fi网络名称"
              onChange={this.onChangeVal('wifiName')}
              extra={(
                <img
                  className="icon-wifi"
                  src={require('./files/icon-wifi.png')}
                  alt="wifi-icon"
                  role="presentation"
                  onClick={this.switchWifi}
                />
              )}
              value={this.wifiInfo.wifiName}
            />
            <div className="tips"><span>不支持5GHz类型的Wi-Fi网络，请勿连接带5G名称的Wi-Fi</span></div>
            <InputItem
              type={showPw ? 'text' : 'password'}
              placeholder="Wi-Fi密码"
              onChange={this.onChangeVal('wifiPassword')}
              extra={(
                <img
                  className="icon-pw"
                  src={require(`./files/icon-pw${!showPw ? '-2' : ''}.png`)}
                  role="presentation"
                  onClick={this.togglePw}
                  alt="icon-pw"
                />
              )}
              value={this.wifiInfo.wifiPassword}
            />
            {
              inputHiddenWifi
              && (
                <List.Item
                  className="wifi-type"
                  extra={this.wifiInfo.wifiType}
                  onClick={this.showModal('modal2')}
                  arrow="horizontal"
                >
                  {'加密性'}
                </List.Item>
              )
            }
            <CheckboxItem
              onChange={this.toggleWifiType}
              checked={inputHiddenWifi}
            >
              {'这个是隐藏网络'}
            </CheckboxItem>
          </List>
        </div>
        <Flex.Item className={`l-img ${inputHiddenWifi ? 'adjust' : ''}`}>
          <div className="design-img" ref={(d) => { this.dimg = d; }}>
            <img
              src={require(`./files/${deviceName}-wifi.png`)}
              alt="连接 WiFi 效果图"
              onLoad={this.imgLoaded}
            />
            <div className="grey">

              请将
              {getDeviceTypeName()}

              尽可能靠近路由器
            </div>
          </div>
        </Flex.Item>
        {
          specialDevice[0] === deviceName
          && (
            <div
              className="grey no-heard"
              role="presentation"
              onClick={this.handleSubmit('tips')}
            >

              扫描二维码连接摄像机
            </div>
          )
        }
        <Button
          className="long-red-btn"
          type="primary"
          onClick={this.handleSubmit('btn')}
        >
          {
            specialDevice[0] === deviceName
              ? '智能快连摄像机'
              : (
                deviceName === 'd1'
                  ? '下一步'
                  : '生成二维码'
              )
          }
        </Button>
        <Modal
          popup
          visible={this.state.modal2}
          onClose={this.onClose('modal2')}
          animationType="slide-up"
        >
          <List
            renderHeader={() => <div> 加密性 </div>}
            className="popup-list"
          >
            {' '}
            {
              this.wifiType.map((i, index) => {
                let extra = null;
                if (i.value === this.wifiInfo.wifiType) {
                  extra = (
                    <Icon
                      type="check"
                      color="#F83B6D"
                    />
                  );
                }
                return (
                  <List.Item
                    key={i.value}
                    extra={extra}
                    onClick={() => {
                      this.chooseWifiType(i.value);
                    }}
                  >
                    {i.label}
                  </List.Item>
                );
              })
            }
          </List>
        </Modal>
        <Modal
          visible={this.qrCodeFiled}
          transparent
          maskClosable={false}
          onClose={this.closeFiled}
          title="生成二维码失败"
          footer={[{ text: '确定', onPress: () => { this.closeFiled(); } }]}
        >
          <div>

            请重新输入wifi！
          </div>
        </Modal>
        <Modal
          visible={noPassword}
          transparent
          maskClosable={false}
          title="注意！"
          footer={[{ text: '取消', onPress: () => { this.setState({ noPassword: false }); } }, { text: '继续', onPress: () => { this.closePasswordTips(); } }]}
        >
          尚未输入WiFi密码，继续连接网络？
        </Modal>
        <audio key="audio1" autoPlay>
          <track kind="captions" />
          <source src={this.inputWifiMp3Src()} type="audio/mp3" />
        </audio>
      </Flex>
    );
  }
}

export default InputWifi;
